import { useQuery } from '@apollo/client/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import {
  GET_PRODUCT,
  type GetProductQueryResult,
  type GetProductQueryVariables,
} from '../../modules/products/operations.js';
import { ProductDetailView } from '../../modules/products/product-detail.js';

export const Route = createFileRoute('/products/$productId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === true || search.edit === 'true',
  }),
  component: ProductDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function ProductDetailPage() {
  const navigate = useNavigate();
  const { productId } = Route.useParams();
  const { edit: startEditing } = Route.useSearch();
  const { data, loading, refetch } = useQuery<GetProductQueryResult, GetProductQueryVariables>(
    GET_PRODUCT,
    { variables: { id: productId } },
  );
  useBreadcrumbLabel(productId, data?.product?.num);

  const setEditingInUrl = (editing: boolean) => {
    void navigate({
      to: '/products/$productId',
      params: { productId },
      search: { edit: editing },
      replace: true,
    });
  };

  return (
    <div>
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading...</div>
      ) : (
        <ProductDetailView
          key={startEditing ? 'edit' : 'view'}
          product={data?.product}
          initialEditing={startEditing}
          onChanged={() => void refetch()}
          onEditingChange={setEditingInUrl}
        />
      )}
    </div>
  );
}
